import { set } from "date-fns";
import React, { useEffect, useState } from "react";
import { Button, Col, ListGroup, ListGroupItem, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import Message from "./Message";
import { FaEdit } from "react-icons/fa";

const VisitCheckListRender = ({ visitCheckLists, setShowEdit }) => {
  return (
    <div>
      {/* <pre>{JSON.stringify(visitCheckLists, null, 2)}</pre> */}

      {visitCheckLists && visitCheckLists.length > 0 ? (
        <ListGroup>
          {visitCheckLists?.map((s) => (
            <ListGroupItem key={s._id || s.idx} className="my-2 border-primary">
              <Row className="text-center text-primary">
                <Col className="mb-2">{s.title}</Col>
              </Row>
              {s.subtitles.map((st) => (
                <Row key={st._id || st.idx} className="px-3 my-2">
                  <Col
                    style={{ backgroundColor: "#54B4D3" }}
                    className="text-white col align-self-center p-2"
                  >
                    {st.subtitle}
                  </Col>
                  <Col className=" col align-self-center pl-3 py-2">
                    {st.label}
                  </Col>
                </Row>
              ))}
            </ListGroupItem>
          ))}
        </ListGroup>
      ) : (
        <Message children={`No scans added yet.`} variant={`info`} />
      )}
      <Row className="width-100 justify-content-end my-2">
        <Col className="mr-2 col-auto">
          <Button variant="outline-primary" onClick={() => setShowEdit(true)}>
            <FaEdit /> Edit Checklists
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default VisitCheckListRender;
